export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./HorarioPage.vue?vue&type=template&id=e20d7cc2&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/HorarioPage.vue?vue&type=template&id=e20d7cc2&scoped=true&
// module id = 609
// module chunks = 18